<template>
  <dsf-exam-layout :exam-loading="loading">
    <template #header>
      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <el-tooltip effect="light" :content="practice.trainingName" placement="right">
            <h3 class="name">{{ practice.trainingName }}</h3>
          </el-tooltip>
        </el-col>
        <el-col :span="8">
          <div class="user">{{ practice.examUserName }}</div>
        </el-col>
      </el-row>
    </template>
    <template #left>
      <p class="sub-title list bg pd-10">答题卡</p>
      <div class="card-list">
        <el-row class="card-tips pd-10">
          <el-col :span="8" class="a1"> 正确：{{ practice.rightNum }} </el-col>
          <el-col :span="8" class="a2 error"> 错误：{{ practice.unrightNum }} </el-col>
          <el-col :span="8" class="a3 not-answer"> 未答：{{ practice.questionsNum - practice.rightNum - practice.unrightNum }} </el-col>
        </el-row>
        <p class="sub-title list pd-10">共{{ practice.questionsNum }}题</p>
        <div class="question-list">
          <div v-for="(item, index) in allStatus" :key="index" :class="item" class="item" @click="go(index + 1)">
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </template>
    <template #main>
      <template v-if="practice.questions">
        <p class="sub-title list bg pd-20" v-html="practice.questions.items.text"></p>
        <div class="exam-content">
          <div class="question">
            <div class="left">
              <dsf-exam-item-box
                :hide-mark="true"
                type="practice"
                :read-only="previewStatus"
                :show-consult="true"
                :subjects="practice.questions"
                :exam-index="practice.questions.dsOrder - 1"
              />
            </div>
          </div>
        </div>
      </template>
    </template>
    <template #right>
      <div class="item">
        <p class="txt">可练习时间</p>
        <p class="result">{{ practice.trainingDateTime }}</p>
      </div>
      <div class="item">
        <p class="txt">当前进度</p>
        <el-progress :percentage="percentageNumber" :format="format"></el-progress>
      </div>
      <dsf-setting-font-size />
      <div v-if="practice.questions && practice.questions.dsOrder > 1" class="exam-submit">
        <el-button class="exam-post before" @click="go()"> 上一题 </el-button>
      </div>
      <div class="exam-submit" v-if="practice.questions">
        <el-button v-if="!practice.questions.showStatus" class="exam-post" @click="examPost">下一题</el-button>
        <el-button v-if="practice.questions.showStatus" class="exam-post next1" @click="next()">下一题</el-button>
      </div>
    </template>
  </dsf-exam-layout>
</template>

<script>
export default {
  name: "ExamPractice",
  provide() {
    return {
      exam: this,
    };
  },
  data() {
    return {
      loading: false,
      disabled: false,
      practice: {},
      allStatus: [],
      form: [],
      data: {},
      nextQuestions: null,
      previewStatus: false,
      subType: "",
      isEnding: false,
    };
  },
  computed: {
    percentageNumber() {
      const { questionsNum, rightNum, unrightNum } = this.practice;
      if (questionsNum) {
        return ((rightNum + unrightNum) * 100) / questionsNum;
      }
      return 0;
    },
  },
  created() {
    this.subType = this.$route?.query?.type;
    this.queryData();
  },
  mounted() {},
  methods: {
    queryData() {
      this.loading = true;
      var params = {
        id: this.$route.query.id,
        type: this.subType,
        recordId: this.$route.query.recordId,
        dsOrder: this.$route.query.dsOrder,
      };

      this.$http
        .get("/training/getTraining", params, $$webRoot.exam)
        .done((res) => {
          if (res.success && res.data) {
            // 加载放到请求接口中  不论加载状态
            this.loading = false;
            if (dsf.isUnDef(res.data.alreadyAnswers)) {
              res.data.alreadyAnswers = [];
            }
            // 显示答案的条件
            if (this.subType == 3 || res.data.questions.isRight) {
              this.previewStatus = true;
              res.data.questions.showStatus = true;
            } else {
              res.data.questions.showStatus = false;
            }

            if (!this.subType) {
              this.WsTime = dsf.ws();
              this.WsTime.$on("/exam/handle/training/record", { recordId: res.data.recordId }, (res) => {});
            }

            this.practice = JSON.parse(JSON.stringify(res.data));
            const questionsNum = res.data.questionsNum;
            for (let i = 1; i <= questionsNum; i++) {
              this.allStatus.push(this.active(i));
            }

            this.markStatus = false;
            this.data[this.practice.questions.dsOrder] = JSON.parse(JSON.stringify(res.data.questions));
            this.$router.replace({
              query: {
                ...this.$route.query,
                recordId: res.data.recordId,
              },
            });
            //刷新我的练习列表/首页练习列表
            if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
              this.$parentOpenerVm = window.opener.openerVms[window.name] || null;
              this.$parentOpenerVm?.reloadData?.();
              this.$parentOpenerVm?.init?.();
            }
          } else {
            // dsf.layer.message(res.message, false);
            this.$router.replace(`/pc/exam/error?msg=${res.message}`);
          }
        })
        .catch((err) => {
          dsf.layer.message(err.message, false);
        });
    },
    // 提交考试
    examPost() {
      if (this.disabled) {
        return;
      }
      // 如果当前题已答
      let findOrder = _.findIndex(this.practice.alreadyAnswers, (o) => o.dsOrder == this.practice.questions.dsOrder);
      let data =
        findOrder >= 0 || (this.practice.questions.result && _.every(this.practice.questions.result, Boolean) && this.practice.questions.answered);
      if (this.subType != 3) {
        if (!data) {
          dsf.layer.message("此题未答，不能到下一题", false);
          return;
        }
      }

      this.disabled = true;
      let params = {
        trainingQuestionsId: "",
        trainingId: this.$route.query.id,
        dsOrder: this.practice.questions.dsOrder,
        recordId: this.practice.recordId,
        result: this.practice.questions.result,
        questionsId: this.practice.questions.examQuestionsId,
        items: this.practice.questions.items.value,
        type: this.subType,
      };
      if (!this.isEnding) {
        this.$http
          .post(
            "/training/nextQuestions",
            JSON.stringify(params),
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
            $$webRoot.exam
          )
          .done((res) => {
            this.disabled = false;
            if (res.success) {
              // console.log("提交数据", res.data, res.data.questions.result);
              if (!res.data.questions && !res.data.result) {
                this.isEnding = true;
                this.disabled = false;
                this.showConfirm();
              } else {
                if (!res.data.questions) {
                  this.isEnding = true;
                  //最后一题
                  if (res.data.result) {
                    // 答题卡 标记样式
                    this.allStatus[this.practice.questions.dsOrder - 1] = res.data.result;
                    // 加入已经回答的数据
                    this.practice.alreadyAnswers.push(this.practice.questions);
                    // 如果当前题答错
                    if (res.data.result !== "right") {
                      // 答题卡记录答错
                      this.practice.unrightNum++;
                      // 当前题不能再次选择
                      this.previewStatus = true;
                      // 下一题内容
                      // this.nextQuestions = res.data.questions;
                      // 当前题显示错误信息
                      this.$set(this.practice.questions, "showStatus", true);
                      // 提交答错记录题答案
                      this.data[params.dsOrder].result = params.result;
                      return;
                    } else {
                      // 当前题不能再次选择
                      this.previewStatus = true;
                      // 当前题显示错误信息
                      this.$set(this.practice.questions, "showStatus", true);
                      // 提交答错记录题答案
                      this.data[params.dsOrder].result = params.result;
                      // 正确
                      this.showConfirm();
                      return;
                    }
                  }
                } else {
                  // 返回当前题正确错误信息
                  if (res.data.result) {
                    // 记录题
                    this.data[res.data.questions.dsOrder] = JSON.parse(JSON.stringify(res.data.questions));
                    // 答题卡 标记样式
                    this.allStatus[this.practice.questions.dsOrder - 1] = res.data.result;
                    // 如果当前题答错
                    if (res.data.result !== "right") {
                      // 答题卡记录答错
                      this.practice.unrightNum++;
                      // 当前题不能再次选择
                      this.previewStatus = true;
                      // // 下一题内容
                      this.nextQuestions = res.data.questions;
                      // // 当前题显示错误信息
                      this.$set(this.practice.questions, "showStatus", true);
                      if (this.data[params.dsOrder]) {
                        // 提交答错记录题答案
                        this.data[params.dsOrder].result = params.result;
                      }
                      // 加入已经回答的数据
                      this.practice.alreadyAnswers.push(this.practice.questions);
                      return;
                    } else {
                      // 正确 直接跳转下一题
                      this.practice.rightNum++;
                      // 可编辑
                      this.previewStatus = dsf.isUnDef(res.data.questions.result) ? false : true;
                      this.$set(this.practice.questions, "showStatus", this.previewStatus);

                      // 加入已经回答的数据
                      this.practice.alreadyAnswers.push(this.practice.questions);
                      this.data[params.dsOrder].result = params.result;
                      if (this.subType == 3 || res.data.questions.result) {
                        res.data.questions.showStatus = true;
                      }
                      // 对了要换当前题更新下
                      this.$router.replace({
                        query: {
                          ...this.$route.query,
                          dsOrder: res.data.questions.dsOrder,
                        },
                      });
                      this.practice.questions = JSON.parse(JSON.stringify(res.data.questions));
                    }
                    // 刷新后返回
                  } else {
                    this.practice.questions = res.data.questions;
                    if (this.subType == 3 || res.data.questions.result) {
                      res.data.questions.showStatus = true;
                    }
                    this.$router.replace({
                      query: {
                        ...this.$route.query,
                        dsOrder: res.data.questions.dsOrder,
                      },
                    });
                    // console.log("当前", res.data.questions.dsOrder);
                    // 可编辑
                    this.previewStatus = false;
                  }
                }
              }
            } else {
              dsf.layer.message(res.message, false);
            }
          })
          .catch((err) => {
            this.disabled = false;
            dsf.layer.message(err.message, false);
          });
      } else {
        this.disabled = false;
        this.showConfirm();
      }
    },
    next() {
      if (!this.isEnding) {
        const dsOrder = this.practice.questions.dsOrder;
        if (dsOrder < this.practice.questionsNum) {
          this.go(dsOrder + 1);
          return;
        }

        // 所有题都在 并且都答了
        if (this.practice.alreadyAnswers.length == this.allStatus.length && _.every(this.allStatus, Boolean)) {
          this.showConfirm();
          return;
        }

        if (!this.nextQuestions) {
          this.examPost();
          return;
        }
        // console.log("跳转", _.indexOf(this.allStatus, ""));
        let nowOrder = _.indexOf(this.allStatus, "") + 1;
        // 把返回的题 赋值给当前题 并改变路由 可编辑
        this.$router.replace({
          query: {
            ...this.$route.query,
            dsOrder: nowOrder,
          },
        });

        this.previewStatus = this.data[nowOrder].result && _.every(this.data[nowOrder].result, Boolean);
        // 给当前题设置可显示 答案
        if (this.previewStatus) {
          this.data[nowOrder].showStatus = true;
        }
        this.practice.questions = JSON.parse(JSON.stringify(this.data[nowOrder]));
        this.nextQuestions = null;
      } else {
        this.showConfirm();
      }
    },
    showConfirm() {
      dsf.layer
        .confirm({
          title: "提示",
          message: this.subType == 3 ? "已查看完练习题,确认关闭吗？" : "已完成所有练习,确认提交练习吗？",
        })
        .done(() => {
          if (this.subType == 3) {
            // 刷新父级
            if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
              this.$parentOpenerVm = window.opener.openerVms[window.name] || null;
              // 刷新首页列表
              this.$parentOpenerVm?.reloadData?.();
              this.$parentOpenerVm?.init?.();
            }
            this.$router.replace({
              path: "practice-result",
              query: {
                trainingId: this.$route.query.id,
              },
            });
          } else {
            this.$http
              .post(
                "/training/complete",
                JSON.stringify({
                  trainingId: this.$route.query.id,
                  recordId: this.$route.query.recordId,
                }),
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                },
                $$webRoot.exam
              )
              .done((res) => {
                // 刷新父级
                if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
                  this.$parentOpenerVm = window.opener.openerVms[window.name] || null;
                  // 刷新首页列表
                  this.$parentOpenerVm?.reloadData?.();
                  this.$parentOpenerVm?.init?.();
                }
                this.$router.replace({
                  path: "practice-result",
                  query: {
                    trainingId: this.$route.query.id,
                  },
                });
              })
              .catch((err) => {
                dsf.layer.message(err.message, false);
              });
          }
        })
        .catch((err) => {});
    },
    go(index) {
      this.isEnding = false;
      this.form = [];
      const dsOrder = index || this.practice.questions.dsOrder - 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          dsOrder: dsOrder,
        },
      });
      this.previewStatus = false;
      if (this.data[dsOrder]) {
        // 如果已提交里面没有找到当前题 。
        let orderStart = _.findIndex(this.practice.alreadyAnswers, (o) => o.dsOrder == dsOrder);
        this.markStatus = this.data[dsOrder].marked || false;
        this.previewStatus =
          this.subType == 3 ? true : orderStart >= 0 ? this.data[dsOrder].result && _.every(this.data[dsOrder].result, Boolean) : false;
        // 下一题有答案 不需要再提交
        this.data[dsOrder].showStatus = this.subType == 3 || orderStart >= 0 ? true : false;
        this.practice.questions = JSON.parse(JSON.stringify(this.data[dsOrder]));
        // console.log("最后一题", this.practice.alreadyAnswers, JSON.parse(JSON.stringify(this.data[dsOrder])));
      } else {
        this.$http
          .get(
            "/training/getQuestions",
            {
              id: this.$route.query.id,
              recordId: this.practice.recordId,
              dsOrder: dsOrder,
            },
            $$webRoot.exam
          )
          .done((res) => {
            if (res.success) {
              // 有答过 显示答案 并不能编辑
              if (this.subType == 3 || (res.data.result && _.every(res.data.result, Boolean))) {
                this.previewStatus = true;
                res.data.showStatus = true;
              }
              // 当前题不标记
              this.markStatus = false;
              // 当前题
              this.practice.questions = res.data;
              // 记录答题卡 获取过的题
              this.data[res.data.dsOrder] = JSON.parse(JSON.stringify(res.data));
            } else {
              dsf.layer.message(res.message, false);
            }
          });
      }
    },
    format() {
      const { questionsNum, rightNum, unrightNum } = this.practice;
      return rightNum + unrightNum + "/" + questionsNum;
    },
    active(index) {
      const hasAnswer = this.practice?.alreadyAnswers?.find((item) => item.dsOrder == index);
      return hasAnswer?.isRight || "";
    },
  },
};
</script>
